import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * The screen's one decisive action, kept in reach: it sticks to the bottom of the viewport while the screen
 * is longer than it, and sits in the flow otherwise. `tabBar` says what it must clear: the customer's tab
 * bar on every width (`always`), the waiter's on phones only (`phone`, the rail takes over from 768 px), or
 * nothing (`none`, the counter and management). Toasts are not used on screens that have one.
 */
export function StickyActions({
  children,
  tabBar = 'always',
  className,
}: {
  children: ReactNode;
  tabBar?: 'always' | 'phone' | 'none';
  className?: string;
}) {
  return (
    <div
      className={cn(
        'sticky z-10 -mx-4 mt-auto border-t border-line bg-white/95 px-4 pt-3 pb-3 backdrop-blur',
        tabBar === 'always' && 'bottom-[calc(3.5rem+env(safe-area-inset-bottom))]',
        tabBar === 'phone' && 'bottom-[calc(3.5rem+env(safe-area-inset-bottom))] md:bottom-0',
        tabBar === 'none' && 'bottom-0',
        className,
      )}
    >
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}
